











import { Component, Prop, Vue } from "@/shared/vuepack";
import moment from "moment";
import _ from "lodash";
import { useDrivewealthAccountPerformanceStore } from "@/shared/store/drivewealthAccountPerformance";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import {
  DrivewealthAccountIdentifierArgs,
  DrivewealthAccountPerformanceSelectOption,
  DrivewealthAccountPerformanceTimePeriod,
} from "@/shared/types";

@Component
export default class AccountPerformanceForm extends Vue {
  drivewealthAccountPerformanceStore = useDrivewealthAccountPerformanceStore();
  drivewealthStore = useDrivewealthStore();

  @Prop()
  accountId: number;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  moment = moment;
  selectedTimePeriod = DrivewealthAccountPerformanceTimePeriod.YearToDate;
  isSubmitting = false;

  mounted (): void {
    this.selectedTimePeriod = this.drivewealthAccountPerformanceStore.selectedTimePeriod;
  }

  get accountIdentifiers (): DrivewealthAccountIdentifierArgs {
    return {
      username: this.username,
      partnerId: this.partnerId,
      accountId: this.accountId
    };
  }

  get frequencySelectOptions (): DrivewealthAccountPerformanceSelectOption[] {
    const selectOptions = [];
     Object.keys(DrivewealthAccountPerformanceTimePeriod)
        .forEach(k => {
          const timePeriodOption = DrivewealthAccountPerformanceTimePeriod[k];
          const lookup = _.find(this.timePeriodOptions, x => x.value === timePeriodOption);
          selectOptions.push(lookup);
        });

     return selectOptions;
  }

  get timePeriodOptions (): DrivewealthAccountPerformanceSelectOption[] {
    return [
      {
        text: "1 Month",
        value: DrivewealthAccountPerformanceTimePeriod.Months1,
      },
      {
        text: "3 Months",
        value: DrivewealthAccountPerformanceTimePeriod.Months3,
      },
      {
        text: "6 Months",
        value: DrivewealthAccountPerformanceTimePeriod.Months6,
      },
      {
        text: "YTD",
        value: DrivewealthAccountPerformanceTimePeriod.YearToDate,
      },
      {
        text: "3 Years",
        value: DrivewealthAccountPerformanceTimePeriod.Years3,
      },
      {
        text: "5 Years",
        value: DrivewealthAccountPerformanceTimePeriod.Years5,
      }
    ];
  }

  getAccountPerformance (timePeriod: DrivewealthAccountPerformanceTimePeriod): void {
    if (this.isSubmitting) {
      return;
    }

    const selectOption = _.find(this.frequencySelectOptions, x => x.value === timePeriod);

    this.isSubmitting = true;

    this.drivewealthAccountPerformanceStore.setSelectedTimePeriod(selectOption.value);
    this.drivewealthAccountPerformanceStore.getAccountPerformance(this.accountIdentifiers)
        .then(x => this.isSubmitting = false);
  }
}
